import ruEventTranslations from './i18n/ru.json'
import enEventTranslations from './i18n/en.json'
import ukEventTranslations from './i18n/uk.json'
import ptEventTranslations from './i18n/pt.json'
import esEventTranslations from './i18n/es.json'
import trEventTranslations from './i18n/tr.json'
import kkEventTranslations from './i18n/kk.json'
import uzEventTranslations from './i18n/uz.json'
import idEventTranslations from './i18n/id.json'
import tgEventTranslations from './i18n/tg.json'
import kyEventTranslations from './i18n/ky.json'
import arEventTranslations from './i18n/ar.json'
import faEventTranslations from './i18n/fa.json'

// Переводы эвентов (корневой ключ halloweenEvent) на все 13 языков
export const eventResources = {
  ru: ruEventTranslations,
  en: enEventTranslations,
  uk: ukEventTranslations,
  pt: ptEventTranslations,
  es: esEventTranslations,
  tr: trEventTranslations,
  kk: kkEventTranslations,
  uz: uzEventTranslations,
  id: idEventTranslations,
  tg: tgEventTranslations,
  ky: kyEventTranslations,
  ar: arEventTranslations,
  fa: faEventTranslations
}
